import React from 'react';

import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';

interface UnderConstructionProps {
  dark?: boolean;
}

const UnderConstruction: React.FC<UnderConstructionProps> = ({ dark = false }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const bgColor = dark ? '#181818' : '#F6B87A';
  const textColor = dark ? '#fff' : '#222';
  const logo = dark
    ? require('assets/images/construction/algoricca_dark_logo.png')
    : require('assets/images/construction/algoricca_logo.png');
  const illustration = require('assets/images/construction/under_construction.png');

  return (
    <Box
      height="85vh"
      width="100%"
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      alignItems="stretch"
      sx={{ bgcolor: bgColor, overflow: 'hidden' }}
    >
      <Box
        flex={1}
        display="flex"
        flexDirection={isMobile ? 'column' : 'row'}
        alignItems="center"
        justifyContent="center"
        px={isMobile ? 2 : 8}
        py={isMobile ? 4 : 0}
        sx={{ overflow: 'hidden', minHeight: 0 }}
      >
        <Box flex={1} textAlign={isMobile ? 'center' : 'left'}>
          <Typography variant={isMobile ? 'h4' : 'h2'} fontWeight={900} color={textColor} mb={2}>
            PÁGINA EM CONSTRUÇÃO!
          </Typography>
          <Typography variant={isMobile ? 'body1' : 'h6'} color={textColor} mb={2}>
            Estamos em fase de reestruturação.
            <br />
            Por favor, aguarde!
          </Typography>
        </Box>

        <Box
          flex={1}
          display="flex"
          justifyContent={isMobile ? 'center' : 'flex'}
          alignItems="center"
          mt={4}
          sx={{ minHeight: 0 }}
        >
          <Box
            component="img"
            src={illustration}
            alt="Página em construção"
            sx={{
              maxWidth: isMobile ? '90vw' : 500,
              width: 'auto',
              height: 'auto',
              maxHeight: isMobile ? '40vh' : '60vh',
            }}
          />
        </Box>
      </Box>

      <Box
        width="100%"
        display="flex"
        justifyContent="flex-end"
        alignItems="center"
        p={1}
        sx={{ flexShrink: 0 }}
      >
        <Box
          component="img"
          src={logo}
          alt="Algoricca Logo"
          sx={{ height: isMobile ? 48 : 96, width: 'auto' }}
        />
      </Box>
    </Box>
  );
};

export default UnderConstruction;
